import type { TextProps } from '@features/powerpoint';
import { headerTextStylesV2 } from './text-styles-v2';

export const contentSlideHeaderV2 = (
  title: TextProps['text'],
  options?: TextProps['options']
): TextProps => ({
  text: title,
  options: { ...headerTextStylesV2.contentSlide, ...options },
});
